import Tooltip from '@/components/Tooltip';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { ReactNode, useId } from 'react';

type Props = {
  children: ReactNode;
  tooltip?: ReactNode;
};

export const TitleWithTooltip = ({ children, tooltip }: Props) => {
  const tooltipId = useId();
  return (
    <div className="grid gap-1 items-center grid-cols-[minmax(min-content,max-content)_min-content]">
      <div className="text-xs text-solid sm:text-sm">{children}</div>
      {tooltip && (
        <Tooltip title={<div id={tooltipId}>{tooltip}</div>} zIndex={10000}>
          <button
            aria-describedby={tooltipId}
            aria-label="Info tooltip"
            tabIndex={0}
          >
            <InformationSolid className="fill-softer" />
          </button>
        </Tooltip>
      )}
    </div>
  );
};
